import { render, staticRenderFns } from "./ArenaForm.vue?vue&type=template&id=60e0a8c5&scoped=true&"
import script from "./ArenaForm.vue?vue&type=script&lang=js&"
export * from "./ArenaForm.vue?vue&type=script&lang=js&"
import style0 from "./ArenaForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArenaForm.vue?vue&type=style&index=1&id=60e0a8c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e0a8c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VFileInput,VForm,VImg,VRow,VSwitch,VTextField})
